<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded && transaction.hash_id.length > 0">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<h3>ព័ត៌មានអំពីប្រតិបត្តិការ</h3>
				<table>
					<tr>
						<td>ប្រភេទប្រតិបត្តិការ</td>
						<td>៖</td>
						<td>
							<span class="green" v-if="transaction.type == 'dep'">ដាក់ប្រាក់</span>
							<span class="late" v-if="transaction.type == 'wit'">ដកប្រាក់</span>
						</td>
					</tr>
					<tr>
						<td style="width: 150px">លេខកូដប្រតិបត្តិការ</td>
						<td style="width: 40px">៖</td>
						<td>{{transaction.hash_id}}</td>
					</tr>
					<tr>
						<td>ចំណាំ</td>
						<td>៖</td>
						<td>{{transaction.note}}</td>
					</tr>
					<tr>
						<td>ថ្ងៃបង្កើត</td>
						<td>៖</td>
						<td>{{config.datelify(transaction.created_date)}}</td>
					</tr>
					<tr>
						<td>បង្កើតដោយ</td>
						<td>៖</td>
						<td>{{transaction.created_by}}</td>
					</tr>
					<!-- <tr>
						<td>ស្ថានភាព</td>
						<td>៖</td>
						<td>
							<span class="green" v-if="transaction.paid == 1">ទូទាត់រួច</span>
							<span class="late" v-if="transaction.paid == 0">មិនទាន់ទូទាត់</span>
						</td>
					</tr> -->

				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50 text-right">
<!--
				<md-button class="md-raised md-success" @click="onPay(transaction.hash_id)" v-if="transaction.paid == 0">
					បញ្ជាក់ថាទូទាត់រួច</md-button> -->
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ព័ត៌មានអំពីកញ្ចប់ឥវ៉ាន់</h3>
				<p v-if="loaded && packageList.length == 0">មិនមាន</p>
				<md-table v-if="packageList.length > 0" style="margin-top: 30px;">
					<md-table-row class="no-hover">
						<md-table-cell class="small-size">លេខកូដ</md-table-cell>
						<md-table-cell class="small-size">ប្រភេទ និងទីតាំង</md-table-cell>
						<md-table-cell class="small-size">អ្នកទទួល</md-table-cell>
						<md-table-cell class="small-size" v-if="$route.params.type != 5">តម្លៃឥវ៉ាន់</md-table-cell>
						<md-table-cell class="small-size">ថ្លៃដឹកជញ្ជូន</md-table-cell>
						<md-table-cell class="small-size"  v-if="$route.params.type == 5">ថ្ងៃអ្នកដឹក</md-table-cell>
						<md-table-cell class="small-size">ស្ថានភាព</md-table-cell>
					</md-table-row>

					<md-table-row class="no-hover" v-for="(pkg, index) in packageList">
						<md-table-cell class="small-size no-hover">​{{ index + 1 }}, <b>{{ pkg.tracking
								}}</b><br>{{config.datelify(pkg.created_date)}}
						</md-table-cell>
						<md-table-cell class="small-size no-hover"><b>{{ pkg.location }}</b><br>{{ pkg.package_type }}
						</md-table-cell>
						<md-table-cell class="small-size no-hover">{{ pkg.receiver_phone }}</md-table-cell>
						<md-table-cell class="small-size no-hover" v-if="$route.params.type != 5">
							<span v-if="pkg.status == 'dlv'">
								<b>{{ config.moneylify(pkg.price, pkg.price_currency) }}</b>
								<br>
								<span v-if="pkg.price == 0">(ទូទាត់ជាមួយអ្នកផ្ញើផ្ទាល់)</span>
								<!-- <span v-else>(មិនទាន់ទូទាត់)</span> -->
							</span>
							<span v-else><b>-----</b><br>({{ config.moneylify(pkg.price, pkg.price_currency)
								}})</span>
						</md-table-cell>
						<md-table-cell class="no-hover small-size">
							<span v-if="pkg.status == 'dlv'">
								<b>{{ config.moneylify(pkg.fee, pkg.fee_currency) }} </b>
								<br>
								<span> ({{config.getStatus(pkg.fee_responsible)}}អ្នកបង់)</span>
							</span>
							<span v-else><b>-----</b><br>({{ config.moneylify(pkg.fee, pkg.fee_currency) }})</span>
						</md-table-cell>
						<md-table-cell class="no-hover small-size" v-if="$route.params.type == 5">
							<span v-if="pkg.status == 'dlv'">
								<b>{{ config.moneylify(pkg.driver_fee, pkg.driver_fee_currency) }} </b>
							</span>
							<span v-else><b>-----</b><br>({{ config.moneylify(pkg.driver_fee, pkg.driver_fee_currency) }})</span>
						</md-table-cell>
						<md-table-cell class="no-hover small-size">
							<span class="error" v-if="pkg.status == 'ndv'">{{ config.getStatus(pkg.status) }}</span>
							<span class="late" v-if="pkg.status == 'wdv'">{{ config.getStatus(pkg.status) }}</span>
							<span class="neutral" v-if="pkg.status == 'dvr'">{{ config.getStatus(pkg.status) }}</span>
							<span class="green" v-if="pkg.status == 'dlv'">{{ config.getStatus(pkg.status) }}</span>
							<span class="return" v-if="pkg.status == 'rtn'">{{ config.getStatus(pkg.status) }}</span>
						</md-table-cell>
					</md-table-row>
					<template v-if="$route.params.type == 2">
						<md-table-row class="no-hover">
							<md-table-cell>​</md-table-cell>
							<md-table-cell></md-table-cell>
							<md-table-cell style="text-align: right;"><b>សរុប:</b></md-table-cell>
							<md-table-cell><b>{{config.moneylify(client.total_usd, 'usd')}} +
									{{config.moneylify(client.total_khr, 'khr')}}</b></md-table-cell>
							<md-table-cell><b>{{config.moneylify(client.total_fee_usd, 'usd')}} +
									{{config.moneylify(client.total_fee_khr, 'khr')}}</b></md-table-cell>
							<md-table-cell></md-table-cell>
						</md-table-row>
						<md-table-row class="no-hover">
							<md-table-cell>​</md-table-cell>
							<md-table-cell></md-table-cell>
							<md-table-cell style="text-align: right;"><b>ទឹកប្រាក់ត្រូវទូទាត់:</b></md-table-cell>
							<md-table-cell colspan="2" style="text-align: center;"><b>{{config.moneylify(client.total_usd -
									client.total_fee_usd,
									'usd')}} +
									{{config.moneylify(client.total_khr - client.total_fee_khr, 'khr')}}</b></md-table-cell>
							<md-table-cell></md-table-cell>
						</md-table-row>
					</template>
					<template v-if="$route.params.type == 3">
						<md-table-row class="no-hover">
							<md-table-cell>​</md-table-cell>
							<md-table-cell></md-table-cell>
							<md-table-cell style="text-align: right;"><b>សរុប:</b></md-table-cell>
							<md-table-cell><b>{{config.moneylify(driver.total_usd, 'usd')}} +
									{{config.moneylify(driver.total_khr, 'khr')}}</b></md-table-cell>
							<md-table-cell><b>{{config.moneylify(driver.total_fee_usd, 'usd')}} +
									{{config.moneylify(driver.total_fee_khr, 'khr')}}</b></md-table-cell>
							<md-table-cell></md-table-cell>
						</md-table-row>
						<md-table-row class="no-hover">
							<md-table-cell>​</md-table-cell>
							<md-table-cell></md-table-cell>
							<md-table-cell style="text-align: right;"><b>ប្រាក់ត្រូវទូទាត់ឱ្យក្រុមហ៊ុនសរុប :</b>
							</md-table-cell>
							<md-table-cell colspan="2" style="text-align: center;"><b>{{config.moneylify(driver.total_usd +
									driver.total_fee_usd,
									'usd')}} +
									{{config.moneylify(driver.total_khr + driver.total_fee_khr, 'khr')}}</b></md-table-cell>
							<md-table-cell></md-table-cell>
						</md-table-row>
					</template>
					<template v-if="$route.params.type == 5">
						<md-table-row class="no-hover">
							<md-table-cell>​</md-table-cell>
							<md-table-cell></md-table-cell>
							<md-table-cell style="text-align: right;"><b>សរុប:</b></md-table-cell>
							<md-table-cell><b>{{config.moneylify(driver_fee.total_fee_usd, 'usd')}} +
									{{config.moneylify(driver_fee.total_fee_khr, 'khr')}}</b></md-table-cell>
							<md-table-cell><b>{{config.moneylify(driver_fee.total_driver_fee_usd, 'usd')}} +
									{{config.moneylify(driver_fee.total_driver_fee_khr, 'khr')}}</b></md-table-cell>
							<md-table-cell></md-table-cell>
						</md-table-row>
						<md-table-row class="no-hover">
							<md-table-cell>​</md-table-cell>
							<md-table-cell></md-table-cell>
							<md-table-cell style="text-align: right;"><b>ប្រាក់ត្រូវទូទាត់ឱ្យអ្នកដឹកជញ្ជូន :</b>
							</md-table-cell>
							<md-table-cell colspan="2" style="text-align: center;"><b>{{config.moneylify(driver_fee.total_driver_fee_usd, 'usd')}} +
									{{config.moneylify(driver_fee.total_driver_fee_khr, 'khr')}}</b></md-table-cell>
							<md-table-cell></md-table-cell>
						</md-table-row>
					</template>
					<!-- <template v-if="$route.params.type == 8">
						<md-table-row class="no-hover">
							<md-table-cell>​</md-table-cell>
							<md-table-cell></md-table-cell>
							<md-table-cell></md-table-cell>
							<md-table-cell style="text-align: right;"><b>សរុប:</b></md-table-cell>
							<md-table-cell><b>{{config.moneylify(office.total_office_fee_usd, 'usd')}} +
									{{config.moneylify(office.total_office_fee_khr, 'khr')}}</b></md-table-cell>
							<md-table-cell></md-table-cell>
						</md-table-row>
						<md-table-row class="no-hover">
							<md-table-cell>​</md-table-cell>
							<md-table-cell></md-table-cell>
							<md-table-cell style="text-align: right;"><b>ប្រាក់ត្រូវទូទាត់ឱ្យការិយាល័យ :</b>
							</md-table-cell>
							<md-table-cell colspan="2" style="text-align: center;"><b>{{config.moneylify(0, 'usd')}} +
									{{config.moneylify(getOfficeFee, 'khr')}}</b></md-table-cell>
							<md-table-cell></md-table-cell>
						</md-table-row>
					</template> -->
				</md-table>
			</div>
		</div>
	</div>
</template>
<script>
	import VueQRCodeComponent from 'vue-qr-generator'
	export default {
		components: {
			'qr-code': VueQRCodeComponent,
		},
		created() {


			// this.getPayment();
			this.init();
		},
		computed: {
			getOfficeFee() {
			}
		},
		data() {
			return {
				loaded: false,
				packageList: [],
				client: {},
				driver: {},
				driver_fee: {},
				office: {},
				transaction: { type: "dep", hash_id: "", created_date: 0 }
			}
		},
		methods: {
			init() {
				this.getTransaction();
				if (this.$route.params.type == 2) {
					this.getClientPackage();
				} else if (this.$route.params.type == 3) {
					this.getDriverPackage();
				} else if (this.$route.params.type == 5) {
					this.getDriverFeePackage();
				}
				// else if (this.$route.params.type == 8) {
				// 	this.getOfficeFeePackage();
				// }
			},
			getTransaction() {
				this.$http.get(this.config.api + "/admin/transaction/get/" + this.$route.params.hash_id).then(data => {
					if (data.body.data.length > 0) {
						this.transaction = data.body.data[0]
					}
					this.loaded = true
				})
			},
			getClientPackage(offset = 0, replace = true) {
				this.$http.post(this.config.api + "/admin/transaction/get/client_package", {
					hash_id: this.$route.params.hash_id
				}).then(data => {
					if (data.body.data.length > 0) {
						this.packageList = data.body.data[0].packageList
						this.client = data.body.data[0]
					}
					this.loaded = true
				})
			},
			getDriverPackage(offset = 0, replace = true) {
				this.$http.post(this.config.api + "/admin/transaction/get/driver_package", {
					hash_id: this.$route.params.hash_id
				}).then(data => {
					if (data.body.data.length > 0) {
						this.packageList = data.body.data[0].packageList
						this.driver = data.body.data[0]
					}
					this.loaded = true
				})
			},
			getDriverFeePackage() {
				this.$http.post(this.config.api + "/admin/transaction/get/driver_fee_package", {
					hash_id: this.$route.params.hash_id
				}).then(data => {
					if (data.body.data.length > 0) {
						this.packageList = data.body.data[0].packageList
						this.driver_fee = data.body.data[0]
					}
					this.loaded = true
				})
			},
			// getOfficeFeePackage() {
			// 	this.$http.post(this.config.api + "/admin/transaction/get/office_fee_package", {
			// 		hash_id: this.$route.params.hash_id
			// 	}).then(data => {
			// 		if (data.body.data.length > 0) {
			// 			this.packageList = data.body.data
			// 		}
			// 		this.loaded = true
			// 	})
			// }
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Transactions/Detail.vue